import {RequestContainer} from "./RequestContainer";
import {useEffect, useState} from "react";
import file from "../requests.txt";

export const RequestPage = (props) => {

    useEffect(() => {
        props.onEnter();
    }, []);

    const [selectedCategory, setSelectedCategory] = useState('');
    const [clientApi, setClientApi] = useState([]);
    const [vacancyApi, setVacancyApi] = useState([]);
    const [candidateApi, setCandidateApi] = useState([]);
    const [employeeApi, setEmployeeApi] = useState([]);
    const [generalApi, setGeneralApi] = useState([]);


    useEffect(() => {
        fetch(file)
            .then(r => r.text())
            .then(text => {
                console.log(file)
                console.log(text)
                classify(JSON.parse(text));
            });
    }, []);

    function compareByNumber(a, b) {
        return a.number - b.number;
    }

    function classify(requests) {
        setClientApi(requests.filter((request) => request.requestName.includes('/client')).sort(compareByNumber));
        setCandidateApi(requests.filter((request) => request.requestName.includes('/candidates')).sort(compareByNumber));
        setVacancyApi(requests.filter((request) => request.requestName.includes('/vacancies')).sort(compareByNumber));
        setEmployeeApi(requests.filter((request) => request.requestName.includes('/employees')).sort(compareByNumber));
        setGeneralApi(requests.filter((request) => !request.requestName.includes('/clients') &&
            !request.requestName.includes('/candidates') &&
            !request.requestName.includes('/vacancies') &&
            !request.requestName.includes('/employees')
        ).sort(compareByNumber));
    }

    function showSnackBar() {
        navigator.clipboard.writeText(document.getElementById("response").innerText)
        var sb = document.getElementById("snackbar");
        sb.className = "show";
        setTimeout(()=>{ sb.className = sb.className.replace("show", ""); }, 3000);
    }

    function onFill(evt, id) {
        const element = document.getElementById(id);
        if (evt.target.value && element.getAttribute("style").includes("border-color:red")) {
            element.setAttribute("style", element.getAttribute("style").replace("border-color:red", "border-color: rgb(150, 150, 150)"));
        }
    }


    return (
        <div className="main-container">
            <div className="request-container">
                <RequestContainer title='Candidate' requests={candidateApi} selected={selectedCategory}
                                  setCategory={setSelectedCategory}></RequestContainer>
                <RequestContainer title='Vacancy' requests={vacancyApi} selected={selectedCategory}
                                  setCategory={setSelectedCategory}></RequestContainer>
                <RequestContainer title='Client' requests={clientApi} selected={selectedCategory}
                                  setCategory={setSelectedCategory}></RequestContainer>
                <RequestContainer title='Employee' requests={employeeApi} selected={selectedCategory}
                                  setCategory={setSelectedCategory}>Employee</RequestContainer>
                <RequestContainer title='General' requests={generalApi} selected={selectedCategory}
                                  setCategory={setSelectedCategory}></RequestContainer>
            </div>
            <div className="side-bar">

                <div className="api"><label htmlFor='apiName'>
                    apiName
                    <span style={{color: "red"}}> *</span>
                </label>
                    <input
                        style={{borderColor: "#969696"}}
                        id='apiName'
                        type='text'
                        required={true}
                        onChange={(e) => onFill(e, 'apiName')}
                    /></div>

                <div className="api">
                    <label htmlFor='apiKey'>
                        apiKey
                        <span style={{color: "red"}}> *</span>
                    </label>
                    <input
                        style={{borderColor: "#969696"}}
                        id='apiKey'
                        type='text'
                        required={true}
                        onChange={(e) => onFill(e, 'apiKey')}
                    />
                </div>

                <div className="api"><label htmlFor='user'>
                    userId
                    <span style={{color: "red"}}> *</span>
                </label>
                    <input
                        style={{borderColor: "#969696"}}
                        id='user'
                        type='text'
                        required={true}
                        onChange={(e) => onFill(e, 'user')}
                    /></div>
                <div style={{marginTop: "10%", width: "85%"}}>
                    <div className="response-header">
                        <div id="status">Status:</div>
                        <i onClick={() => {showSnackBar()}} className="copy-button"></i></div>
                    <span id="snackbar">Successfully Copied</span>
                    <scroll-container>
                        <pre id='response'></pre>
                    </scroll-container>
                </div>
            </div>
        </div>
    )

}